import PoLookup from '@/store/modules/poLookup/constants';

export default {
  [PoLookup.mutationTypes.executeSearch](state, searchText) {
    const localState = state;
    localState.searchStatus = PoLookup.searchStatusEnum.searching;
    localState.searchText = searchText;
  },

  [PoLookup.mutationTypes.searchFinished](state, searchResult) {
    const localState = state;
    localState.searchStatus = PoLookup.searchStatusEnum.searchCompleted;
    localState.searchResults = searchResult;
  },

  [PoLookup.mutationTypes.clearSearchResults](state) {
    const localState = state;
    localState.searchStatus = PoLookup.searchStatusEnum.notSearched;
    localState.searchResults = null;
  },
};
